<template>
  <v-dialog
    v-model="show"
    scrollable
    persistent
    :overlay="false"
    min-width="500px"
  >
    <v-card>
      <v-toolbar dark color="#E3002C" class="d-flex align-center">
        <v-btn icon dark @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <paginated-search-table
          :endpoint="endpoint"
          :headers="headers"
          :searchLabel="searchLabel"
          :ordering="ordering"
          :filterString="filterString"
          :canEdit="canEdit"
          :canDelete="canDelete"
          :canAdd="canAdd"
          :searchOnURL="searchOnURL"
          @itemSelected="onItemSelected($event)"
        ></paginated-search-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import PaginatedSearchTable from "@/components/PaginatedSearchTable.vue";

export default {
  name: "PaginatedSearchDialog",

  components: {
    PaginatedSearchTable
  },

  props: {
    title: {
      type: String,
      default: "Buscar..."
    },
    show: {
      type: Boolean,
      default: false
    },
    endpoint: {
      type: String,
      required: true
    },
    headers: {
      type: Array,
      default: function() {
        return [];
      }
    },
    searchLabel: {
      type: String,
      default: "Buscar"
    },
    ordering: {
      type: String,
      default: null
    },
    filterString: {
      type: String,
      default: null
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    canAdd: {
      type: Boolean,
      default: false
    },
    searchOnURL: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onClose() {
      this.$emit("cancel");
    },
    onItemSelected(item) {
      this.$emit("itemSelected", item);
    }
  }
};
</script>
